module.exports = __webpack_public_path__ + "c2488bfda16e6a811f62414da90e51e4.ttf";